import { Directive } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { InquiryService } from "../services/inquiry.service";
import { ModalSnackbarService } from "../services/modal-snackbar.service";
import { FileUtilsService } from "../services/file-utils.service";

@Directive()
export abstract class AbstractInquiryCreateComponent {
  form!: FormGroup;
  selectedFiles: File[] = [];

  constructor(
    protected  fb: FormBuilder,
    protected  service: InquiryService,
    protected  snackBar: ModalSnackbarService,
    protected  fileUtils: FileUtilsService
  ) {}

  onDragOver(event: DragEvent): void {
    this.fileUtils.onDragOver(event);
  }

  onDrop(event: DragEvent): void {
    const newFiles = this.fileUtils.extractValidDroppedFiles(event, this.selectedFiles);
    if (!newFiles) {
      this.snackBar.show(`ファイルは最大 ${this.fileUtils.MAX_FILE_COUNT} 個までです`);
      return;
    }

    this.fileUtils.addFiles(this.selectedFiles, newFiles, files => {
      this.updateSelectedFiles(files);
    });
  }

  onFileChange(event: Event): void {
    const newFiles = this.fileUtils.extractValidSelectedFiles(event, this.selectedFiles);
    if (!newFiles) {
      this.snackBar.show(`ファイルは最大 ${this.fileUtils.MAX_FILE_COUNT} 個までです`);
      return;
    }

    this.fileUtils.addFiles(this.selectedFiles, newFiles, updated => {
      this.updateSelectedFiles(updated);
      const input = event.target as HTMLInputElement;
      if (input.files) {
        input.value = ''; // 同じファイルでも選び直し可能にする
      }
    });
  }

  removeFile(index: number): void {
    this.fileUtils.removeFile(this.selectedFiles, index, updated => {
      this.updateSelectedFiles(updated);
    });
  }

  private updateSelectedFiles(files: File[]) {
    this.selectedFiles = files;
    this.form.get('files')?.setValue(files);
    this.form.get('files')?.updateValueAndValidity();
  }

}
